module.exports = __webpack_public_path__ + "img/QOOKER_Box04.0589720d.jpg";